import { omit } from 'lodash';
import React, { FC } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { twMerge } from 'tailwind-merge';

type DatePickerInputProps = ReactDatePickerProps & {
  id?: string;
  label?: string;
  className?: string;
  error?: string;
  iconComponent?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  extraInfo?: string;
  isViewMode?: boolean;
};

export const DatePickerInput: FC<DatePickerInputProps> = ({ id, name, label, className, onChange, error, extraInfo, isViewMode, ...rest }) => {
  let inputStyle =
    'inline-flex w-full px-2 sm:text-sm border border-gray-300 focus:border-brand-600 focus:border focus:outline-none rounded-md placeholder-gray-400';

  if (rest.selected) {
    inputStyle = twMerge(inputStyle, 'border-primary-700');
  }

  if (rest.icon) {
    inputStyle = twMerge(inputStyle, 'pl-10');
  }

  if (error) {
    inputStyle = twMerge(inputStyle, 'border-red-500 hover:border-red-500 focus:border-red-500 outline-none');
  }

  if (rest.disabled) {
    inputStyle = twMerge(inputStyle, 'bg-gray-200 text-gray-500');
  }

  const handleChange = (date: Date | null, event: React.SyntheticEvent<any, Event> | undefined) => {
    if (onChange) {
      onChange(date, event);
    }
  };

  return (
    <div className='inline-flex w-full flex-col text-left'>
      {label && (
        <label htmlFor={name} className='block py-2 text-sm font-medium text-gray-700'>
          {label}
        </label>
      )}

      <DatePicker
        {...omit(rest, 'icon')}
        id={id}
        name={name}
        onChange={handleChange}
        className={className ? twMerge(inputStyle, className) : inputStyle}
        disabled={rest.disabled || isViewMode}
      />

      {extraInfo && <p className='mt-2 text-sm text-gray-800'>{extraInfo}</p>}
      {error && <p className='mt-2 text-sm text-red-600'>{error}</p>}
    </div>
  );
};
